import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { borderStyle } from "../../styles/consts";
import ActivityTab from "./ActivityTab";
import MatchStatsTab from "./MatchStatsTab";

export default function AlqemiAnalytics() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Box sx={{ border: borderStyle }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Activity" />
            <Tab label="Match Stats" />
          </Tabs>
        </Box>
        <Box sx={{ padding: 3 }}>
          {activeTab === 0 && <ActivityTab />}
          {activeTab === 1 && <MatchStatsTab />}
        </Box>
      </Box>
    </Box>
  );
}
